/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ProfileInputs */

const en_nav_profile = /** @type {(inputs: Nav_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const pt_br2_nav_profile = /** @type {(inputs: Nav_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Nav_ProfileInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const nav_profile = /** @type {((inputs?: Nav_ProfileInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ProfileInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_profile(inputs)
	return pt_br2_nav_profile(inputs)
});